<template>
  <div class="panel login_box" :class="idStr" :ref="idStr">
    <div class="panel_body">
      <ul>
        <template v-for="(item, index) in dataList2">
          <li
            class="item login_box-item"
            :key="index"
            :class="{
              animate__backInRight: !index,
              animate__backInLeft: !!index,
            }"
          >
            <div class="btn" v-html="item.label" @click.stop="item.fun" />
          </li>
        </template>
      </ul>
    </div>
  </div>
</template>
<script>
const idStr = "login_box";
import countTo from "vue-count-to";
import { addWOW } from "@/utils";
import { REGISTER_URL } from "@/config";

export default {
  name: idStr,
  components: { countTo },
  data() {
    return {
      title: "登录注册",
      idStr,
      dataList2: [
        { label: "登&ensp;&ensp;录", fun: () => this.goLogin(1) },
        { label: "注&ensp;&ensp;册", fun: () => this.goLogin(3) },
      ],
    };
  },
  watch: {
    dataList2: () => {
      addWOW("login_box-item");
    },
  },
  methods: {
    goLogin(type) {
      if (type === 3) {
        window.location.href = REGISTER_URL + "?redirect=" + encodeURIComponent(window.location.href);
      } else {
        this.$router.push({ path: "/login", query: { type } });
      }
    },
  },
};
</script>
<style lang="less" scoped>
@import "./index.less";
</style>
